import React from 'react';
import { Legacy_Board as LegacyBoardContent } from './Offers_Board';

export const Legacy_Board = (props) => {
    return <LegacyBoardContent {...props} />;
};

export default Legacy_Board;
